const css = `.OPwWXW__minimap{max-height:100%;cursor:grab;margin:0 8px;position:relative}.OPwWXW__dragging{cursor:grabbing}.OPwWXW__months{grid-template-columns:repeat(1,max-content);row-gap:8px;padding:8px 4px;transition:transform .25s ease-out;display:grid}.OPwWXW__highlight{width:100%;pointer-events:none;z-index:1;transition:transform .25s ease-out;position:absolute;top:0;box-shadow:inset 0 0 2px 2px #c8e2ff}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"dragging":"OPwWXW__dragging","highlight":"OPwWXW__highlight","minimap":"OPwWXW__minimap","months":"OPwWXW__months"};
